import React, { useRef, useEffect, useState } from 'react';
import columnClasses from '../columns.css';
import Select from 'react-select';
import { OptionCustomer } from '../../../UI/select';
import { customStylesContact } from '../../../UI/select-styles';
import DataTableInput from '../../../Input/input';
import { menuPlacement, menuPlacementR1 } from '../selectHelper';

const propsAreEqual = (prev, next) => {
    return prev.focus === next.focus
        && prev.active === next.active
        && prev.row === next.row;
}

const Contact = ({ coords, row, width, disabled, contacts, contactsOut, contactsIn, isRuleFound, focus, active, elementFocused, isR1, handleContact }) => {
    const contactActiveInput = useRef(null);
    const contactPassiveInput = useRef(null);
    const [mouseActive, setMouseActive] = useState(false);

    useEffect(() => {
        if (!disabled) {
            if (!active)
                setMouseActive(false);
        }
        if (contactPassiveInput.current)
            contactPassiveInput.current.blur();
        if (contactActiveInput.current) {
            if (active)
                contactActiveInput.current.focus();
        }
    }, [active, contactActiveInput, contactPassiveInput]);

    const selectTemplateClicked = (elem) => {
        setMouseActive(true);
        elementFocused();
    }

    const onSelectContact = (contactValue) => {
        handleContact(contactValue,row);
    }

    const contactSelectKeyDown = e => {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            onSelectContact(null);
        }
    }

    const contactValue = ((row.Coding.length && row.contactId) && !isRuleFound(row)) ? contacts.find(item => item.value === row.contactId) : null;
    if ((active !== true || disabled)) {
        return <DataTableInput
            inputElementType="text"
            value={contactValue ? contactValue.label : `Select...`}
            onClick={(e) => { if (!disabled) selectTemplateClicked(e.target) }}
            onFocus={elementFocused}
            // elementRef={accountInputTemplate}
            disabled={disabled}
            loading={mouseActive}
        />
    } else {
        return <Select
            name={`${row.BankDataGUID}_contact`}
            ref={contactActiveInput}
            onChange={(value) => onSelectContact(value)}
            value={contactValue}
            isClearable={false}
            isDisabled={disabled}
            onFocus={elementFocused}
            isOptionDisabled={(option) => option.isActive === false}
            blurInputOnSelect
            closeMenuOnSelect
            placeholder={row.Coding.length > 1 ? '' : 'Select...'}
            components={{ Option: OptionCustomer }}
            options={row.Amount < 0 ? contactsOut : contactsIn}
            styles={customStylesContact}
            maxWidth={width}
            className={columnClasses.inputElement}
            menuPortalTarget={!isR1 ? document.getElementById('DataTable') : ''}
            defaultMenuIsOpen={mouseActive}
            onKeyDown={contactSelectKeyDown}
            menuPlacement={isR1 ? menuPlacementR1(coords.x, window.innerHeight * 0.38, 'bottom') : menuPlacement(coords.x, window.innerHeight * 0.38, 'auto')}//0.38 is comming from max Heigth of menu(in this case customStylesAcc.menulist.maxHeight is 38vh)
        />
    }
}

export default React.memo(Contact, propsAreEqual);;


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/Contact/contact.js